<script lang="ts">
    import { onMount } from 'svelte';
    import clipboardjs from 'clipboard';
    import { fly } from 'svelte/transition';

    export let title: string;
    export let url: string;
    export let text: string = '';
    $: encodedText = text ? encodeURI(text) : '';

    let shareSupported = false;
    let copyIndicator = false;
    let innerWidth: number;

    $: mobile = innerWidth && innerWidth < 768 ? true : false;

    onMount(() => {
        shareSupported = navigator.share ? true : false;
        const clipboard = new clipboardjs('.copy');
        clipboard.on('success', () => {
            copyIndicator = true;
            setTimeout(() => {
                copyIndicator = false;
            }, 500);
        });

        return () => {
            if (clipboard) clipboard.destroy();
        };
    });

    async function handleShare() {
        const shareData = {
            title,
            text,
            url,
        };

        // Share must be triggered by "user activation"
        if (navigator.share) {
            await navigator.share(shareData);
        } else {
            console.error('navigator.share is not supported in this browser.');
            shareSupported = false;
        }
    }
</script>

<svelte:window bind:innerWidth />

{#if shareSupported && mobile}
    <button on:click={handleShare} class="text-blue">Share</button>
{:else}
    <h3>Share on</h3>
    <ul class="flex flex-wrap gap-x-1 pl-5 text-blue">
        <li>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} target="_blank">
                Facebook,
            </a>
        </li>
        <li>
            <a
                href={`https://pinterest.com/pin/create/button/?url=${url}&media=&description=${encodedText}`}
                target="_blank"
            >
                Pinterest,
            </a>
        </li>
        <li>
            <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}`} target="_blank">
                LinkedIn,
            </a>
        </li>
        <li>
            <a
                href={`https://twitter.com/intent/tweet?url=${url}&text=${encodedText}`}
                target="_blank"
            >
                Twitter,
            </a>
        </li>

        <li>
            <a href={`mailto:?&subject=${title}&cc=&bcc=&body=Link: ${url}`} target="_blank">
                Mail,</a
            >
        </li>

        <li>
            <button class="copy" data-clipboard-text={`${url}`}
                >copy link

                {#if copyIndicator}
                    <span class="inline-block" in:fly={{ y: 10 }} out:fly={{ y: -10 }}>✅</span>
                {/if}
            </button>
        </li>
    </ul>
{/if}
